import { put, takeLatest, call } from "redux-saga/effects";
import {
    GET_APPROVED_AGGREGATORS_FOR_CARRIER,
    GET_APPROVED_AGGREGATORS_FOR_CARRIER_SUCCESS,
    GET_APPROVED_AGGREGATORS_FOR_CARRIER_FAILED,
} from "../../actions/ActionType";
import { API_ENDPOINT } from "../../URLs/ApiEndpoints";
import { makeSecuredPostRequest } from "../../../appApi/AppApi";
import { createActionOf } from "../../actions/ActionCreator";

const TAG = "getApprovedAggregatorsForCarrierSaga.js";

function* workerGetApprovedAggregatorsForCarrier(payLoad) {
  try {
    const response = yield call(
        makeSecuredPostRequest,
        API_ENDPOINT.GET_APPROVED_AGGREGATORS_FOR_CARRIER,
    );
    yield put(createActionOf(GET_APPROVED_AGGREGATORS_FOR_CARRIER_SUCCESS, 1, response));
  } catch (error) {
    console.error(TAG, "Worker get country failed: " + error.message);
    yield put(createActionOf(GET_APPROVED_AGGREGATORS_FOR_CARRIER_FAILED, 2, error));
  }
}

export const watchGetApprovedAggregatorsForCarrier = takeLatest(
    GET_APPROVED_AGGREGATORS_FOR_CARRIER,
    workerGetApprovedAggregatorsForCarrier,
);